import { reducerWithInitialState } from "typescript-fsa-reducers";
import { deselectCells, selectCell } from "../selectedCells/actions";
import { buildHighlightedCells } from "./helpers";
import { HighlightedCell } from "./types";

export type HighlightedCellState = HighlightedCell[];

export default reducerWithInitialState<HighlightedCellState>([])
  .case(deselectCells, _ => [])
  .case(selectCell, (_, selectedCell) => {
    const highlightedCells = buildHighlightedCells(
      selectedCell.account,
      selectedCell.period
    );
    return highlightedCells;
  });



// WEBPACK FOOTER //
// ./src/spread/model/highlightedCells/reducer.ts